import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ThemeService } from './shared/services/themes.service';
import { IStmxHost } from 'ngx-exdr-stmx-common';
import { StmxHostService } from './shared/services/stmx-host.service';
import { IStmxGroup } from 'ngx-exdr-stmx-common';
import { StmxGroupService } from './shared/services/stmx-group.service';
import { environment } from '../environments/environment';
import { MultiTranslateHttpLoader } from './shared/services/multi-translate-httploader.service';
import { httpAuthInterceptorFn } from './shared/inteceptors/http-auth.interceptor';
import { httpCacheInterceptorFn } from './shared/inteceptors/http-cache.interceptor';
import { InlineSVGConfig } from 'ng-inline-svg-2';
import { SVGConfig } from './shared/services/svg-config.service';

const VERSION: string = '1.0.0';
export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: `.json?v=${VERSION}` }, // Application translation files
    { prefix: './assets/i18n-technadopt/', suffix: `.json?v=${VERSION}` } // Library translation files
  ]);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
      })
    ),
    {
      provide: IStmxHost,
      useClass : StmxHostService // Provide the StmxHostService as the implementation of IStmxHost to other stmx libraries
    },
    {
      provide: IStmxGroup,
      useClass : StmxGroupService // Provide the StmxgroupService as the implementation of IStmxGroup to other stmx libraries
    },
    {provide: 'environment', useValue: environment},
    /**
     * Use of Factory function to initialize the application's theme.
    */
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppDynamicTheme,
      multi: true,
      deps: [ThemeService]
    },
     
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([httpAuthInterceptorFn, httpCacheInterceptorFn]),withInterceptorsFromDi(), withFetch()),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }).providers!,
    provideClientHydration(),
    { provide: InlineSVGConfig, useClass: SVGConfig }
  ]
};


/**
 * Factory function to initialize the application's theme.
 * 
 * @param themeService - Instance of ThemeService used to initialize the theme.
 * @returns A function that returns a promise to initialize the theme.
 */
export function initializeAppDynamicTheme(themeService: ThemeService): () => Promise<void> {
return () => themeService.initializeTheme();
}